import {
  Component,
  OnInit,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { UIComponents, Item } from '@ntap/core';
import { Observable, map, first, tap } from 'rxjs';
import { OdabirPovezanogAgentaProviderDirective } from './odabir-povezanog-agenta.provider';
import { Agent } from '@app/shared/models/agent';

@Component({
  selector: 'app-odabir-agenta',
  templateUrl: './odabir-agenta.html'
})
export class SelectAgentComponent implements OnInit, AfterViewInit {
  @Output()
  itemSelected = new EventEmitter<Agent[]>();

  @ViewChild(OdabirPovezanogAgentaProviderDirective)
  appOdabirPovezanogAgentaProvider: OdabirPovezanogAgentaProviderDirective;

  tablica = [
    'en~agent~naziv',
    'en~agent~vrsta_agenta',
    'en~agent~podvrsta_agenta',
    'en~agent~oblik_vlasnistva',
    'en~agent~vrijeme_djelovanja_labela',
    'en~agent~status',
    'en~agent~status_obrade_id'
  ];

  lista = [
    'en~agent~identifikator',
    'en~agent~naziv',
    'en~agent~content_id',
    'en~agent~vrsta_agenta',
    'en~agent~oblik_vlasnistva',
    'en~agent~status',
    'en~agent~povijest',
    'en~agent~glavni_identifikator'
  ];

  grid = [
    'en~agent~identifikator',
    'en~agent~naziv',
    'en~agent~content_id',
    'en~agent~vrsta_agenta',
    'en~agent~oblik_vlasnistva',
    'en~agent~status'
  ];

  INIT_COMP_ID = UIComponents.LISTVIEW;
  currentViewName: string;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};
  currentViewClass: string;

  disabled$: Observable<boolean>;

  private selectedItems$: Observable<Item[] | null>;

  ngOnInit(): void {
    this.currentViewName = 'agent';
    this.currentViewState = {};
    this.currentViewStateFilter = {};
  }

  public ngAfterViewInit(): void {
    this.selectedItems$ = this.appOdabirPovezanogAgentaProvider.selectedItems$;
    this.disabled$ = this.selectedItems$.pipe(map((i) => !i || i.length == 0));
  }

  public selectItem() {
    this.selectedItems$
      .pipe(
        first(),
        tap((items) => {
          if (!!items && items.length > 0) {
            this.itemSelected.next(items as Agent[]);
          }
        })
      )
      .subscribe();
  }
}
